import { render } from "./StagesProgress.vue?vue&type=template&id=d8ce0cb8&scoped=true"
import script from "./StagesProgress.vue?vue&type=script&lang=js"
export * from "./StagesProgress.vue?vue&type=script&lang=js"

import "./StagesProgress.vue?vue&type=style&index=0&id=d8ce0cb8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ce0cb8"]])

export default __exports__